import React, {useEffect, useRef, useState} from 'react'
import {KTSVG} from '../../../../../_metronic/helpers'
import {Tooltip} from 'react-tooltip'
import {
  addPot,
  blockStatutPot,
  getAllFournisseursPOT,
  getAnomalie,
  updatePot,
} from '../../../../../components/requests'
import * as Yup from 'yup'
import {potInitValues} from '../../../../../components/Models'
import {Modal} from 'bootstrap'
import InputGroup from 'react-bootstrap/InputGroup'
import {AddFournisseurPOTModal} from '../../../referentielFournisseurPOT/AddFournisseurPOTModal'
import {useNavigate} from 'react-router-dom'
import {useLocation} from 'react-router'
import {FileWithPreview, MultiFilePicker} from '../../../../../components/MutliFilePicker'
import {copyText} from '../../../../../components/renders'
import {useFilAriane} from '../../../../contexts/FilArianeContext'
import {toast} from 'react-toastify'

const API_URL = process.env.REACT_APP_API_URL
const pot_url = `${API_URL}/photos/POT/`

const ModalPOT = (props) => {
  const {
    piece,
    showToastPOT,
    setPiecesProps,
    // panier,
    setPanier,
    // allPieces,
    piecesProps,
    setAllPieces,
    state,
    dataClientInfos,
    isEdit = false,
    listPot = null,
    setListPot,
    listDemande = null,
    setListDemande,
    provenances,
    setPieceSelected,
    setDemandeClient,
    isEditPanier = false,
    isEditPiece = false,
    setIsEditPanier,
    setIsEditPiece,
    pieceInstance
  } = props
  const {
    listePOTAriane,
    selectedPOTAriane,
    setDemandeAriane,
    setListePOTAriane,
    setSelectedPOTAriane,
  } = useFilAriane()

  const modalRef = useRef<HTMLDivElement | null>(null)
  const navigate = useNavigate()
  const [marge, setMarge] = useState<any>(30)
  const [remise, setRemise] = useState<any>(0)
  const [prixAchat, setPrixAchat] = useState<any>('')
  const [prixVente, setPrixVente] = useState<any>('')
  const location = useLocation()
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
  const [pieces, setPieces] = useState<any>({
    code: '',
    nomPiece: '',
    fournisseur: '',
    prixAchat: '',
    prixVente: '',
    delai: 2,
    ne: '',
    anomalie: '',
    commandeFournisseur: '',
    provenance: '',
    marge: marge,
    remise: remise,
  })
  const [errors, setErrors] = useState<any>({})
  const [loading, setLoading] = useState<boolean>(false)
  const [loadingFournisseur, setLoadingFournisseur] = useState<boolean>(true)
  const [loadingAnomalie, setLoadingAnomalie] = useState<boolean>(true)
  const [optionFournisseur, setOptionFournisseur] = useState<any | undefined>([])
  const [optionFournisseurSelected] = useState<any | undefined | null>()
  const [optionAnomalieSelected] = useState<any | undefined | null>()
  const [anomalies, setAnomalies] = useState<any | undefined>([])
  const [anomalieValue, setAnomalieValue] = useState<any>('')

  const [provenanceValue, setProvenanceValue] = useState<any>('')
  const [optionProvenanceSelected] = useState<any | undefined | null>()

  const [potObj, setPotObj] = useState<any>(null)

  const [openCreationFournisseurPOTModal, setOpenCreationFournisseurPOTModal] =
    useState<boolean>(false)
  const [images, setImages] = useState<FileWithPreview[]>([])
  const [checkCopy, setCheckCopy] = useState<string | null>(null)
  const [pcs, setPcs] = useState<any>(piece)

  const validationSchema = Yup.object({
    code: Yup.string().required('Ce champ est requis'),
    nomPiece: Yup.string().required('Ce champ est requis'),
    fournisseur: Yup.string().required('Ce champ est requis'),
    anomalie: Yup.string().required('Ce champ est requis'),
    provenance: Yup.string().required('Ce champ est requis'),
    prixAchat: Yup.number()
      .typeError('Ce champ est requis')
      .required('Ce champ est requis')
      .positive("Le prix d'achat doit être positif")
      .test('is-decimal', "Le prix d'achat doit avoir 2 décimales maximum", (value) => {
        return /^\d+(\.\d{1,2})?$/.test(String(value))
      }),
    prixVente: Yup.number()
      .typeError('Ce champ est requis')
      .required('Ce champ est requis')
      .positive('Le prix de vente doit être positif')
      .test('is-decimal', 'Le prix de vente doit avoir 2 décimales maximum', (value) => {
        return /^\d+(\.\d{1,2})?$/.test(String(value))
      }),
    commandeFournisseur:
      isEdit && !isEditPanier && !isEditPiece
        ? Yup.string().required('Ce champ est requis')
        : Yup.string(),
  })

  const nomPiece = pieces?.nomPiece
  const marque = piece?.demandePiece?.marque ?? piece?.marque
  const modele = piece?.demandePiece?.modele ?? piece?.modele
  const commandeFournisseur = pieces?.commandeFournisseur
  const code = pieces?.code

  // Libellé POT automatique
  let libelle =
    nomPiece && marque && modele && commandeFournisseur && code
      ? `${nomPiece}-${marque}-${modele}-${commandeFournisseur}-${code}`
      : ''

  const toggleCreationFournisseurPOTModal = (val: boolean) => {
    setIsModalOpen(!val)
    setOpenCreationFournisseurPOTModal(val)
  }

  // Pour le formatage du code NE
  const formatNE = (demandeId) => {
    return '8' + demandeId?.toString()?.padStart(5, '0')
  }

  useEffect(() => {
    if (piece) setPcs(piece)
  }, [piece])

  // Récupération des fournisseurs du pièces POT
  const getFournisseurPot = () => {
    setLoadingFournisseur(true)
    getAllFournisseursPOT()
      .then((fournisseurRequest) => {
        if (fournisseurRequest?.status === 200) {
          if (fournisseurRequest?.data !== undefined) {
            const optionsFournisseur = fournisseurRequest?.data?.map((item) => ({
              value: item.id,
              label: item.nom,
            }))
            setLoadingFournisseur(false)
            setOptionFournisseur(optionsFournisseur)
          }
        } else {
          setIsModalOpen(false)
        }
      })
      .catch((e) => {
        setIsModalOpen(false)
      })
  }

  // Récupération des anomalies du pièces POT
  const getAnomaliePot = () => {
    setLoadingAnomalie(true)
    getAnomalie()
      .then((anomalieRequest) => {
        if (anomalieRequest?.status === 200) {
          if (anomalieRequest?.data !== undefined) {
            const transformedData = anomalieRequest.data.map((item) => ({
              value: item.id,
              label: item.libelle,
            }))
            setLoadingAnomalie(false)
            setAnomalies([...transformedData])
          }
        }
      })
      .catch((e) => {
        console.error(e)
      })
  }

  // Saisie des valeurs par défaut
  useEffect(() => {
    setImages([])
    if (isModalOpen) {
      setAnomalieValue('')
      // Chargement des fournisseurs à l'ouverture du modal

      getFournisseurPot()
      getAnomaliePot()
    } else {
      if (setPieceSelected) setPieceSelected(null)
      setSelectedPOTAriane(null)
    }
  }, [isModalOpen])

  // UseEffect pour mettre à jour les valeur de pieces une fois que fournisseur et anomalie sont chargés
  useEffect(() => {
    const tp = piece?.typePiece
    if (isEdit) {
      const optionFound = optionFournisseur?.find((option) => option.label === piece?.fournisseur)
      setPieces({
        ['code']: piece?.code ?? '',
        ['nomPiece']: piece?.nomPiece ?? '',
        ['ne']: piece?.NE ?? '',
        ['fournisseur']: optionFound?.value ?? '',
        ['delai']: piece?.delaisLivraison ?? '',
        ['prixAchat']: piece?.prixAchatTTC ?? '',
        ['prixVente']: piece?.prixVenteTTC ?? '',
        ['anomalie']: piece?.anomaliePOT?.id ?? '',
        ['commandeFournisseur']: piece?.commandeFournisseur ?? '',
        ['provenance']: piece?.provenance?.id ?? '',
        ['remise']: 0,
        ['marge']: piece?.marge ?? '',
      })

      // Transformation des noms d'image en tableau d'objets avec preview
      const newFiles: any = Array.from(piece?.images ?? []).map((fileName) => ({
        id: crypto.randomUUID(), // Évite les bugs d'index lors des suppressions
        file: {
          name: fileName,
        },
        preview: `${pot_url}${fileName}`, // url d'images enrégistrer dans le projet
      }))
      setImages(newFiles)

      setAnomalieValue(piece?.anomaliePOT?.id ?? '')
      setProvenanceValue(piece?.provenance?.id ?? '')
    } else {
      setPieces((prevPieces) => ({
        ...prevPieces,
        ['code']: !tp
          ? ''
          : tp?.sousCategorie?.categorie?.code + '' + tp?.sousCategorie?.code + '' + tp?.code,
        ['nomPiece']: !tp ? '' : pcs?.typePiece?.nom,
        ['ne']: formatNE(pcs?.demande?.id),
        ['remise']: 0,
        ['marge']: pcs?.marge ?? 30,
        ['delai']: 2,
      }))
    }
  }, [isEdit, piece, optionFournisseur, anomalies, pcs])

  useEffect(() => {
    setPrixVente(pieces?.prixVente !== '' ? pieces?.prixVente : prixVente)
    setPrixAchat(pieces?.prixAchat !== '' ? pieces?.prixAchat : prixAchat)
    setMarge(pieces?.marge !== '' ? pieces?.marge : marge)
    setRemise(0)
  }, [pieces])

  // Mise à jour de chaque attribut
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const floatFields = ['code', 'prixAchat', 'prixVente', 'commandeFournisseur', 'remise', 'marge']

    const {name, value} = e.target

    // Gestion des erreurs
    setErrors((prevErrors: any) => ({
      ...prevErrors,
      [name]: '',
    }))

    // Mise à jour de l'objet pièce
    setPieces((prevPieces) => ({
      ...prevPieces,
      [name]: floatFields.includes(name) ? value.replace(',', '.') : value,
    }))
  }

  // - ( si depuis liste piece ou panier => affichage uniquement si le statut est à proposer ) et si non toujours affiché
  let shouldDisplayButton = true
  if (isEditPiece || isEditPanier) {
    if (piece?.status !== 'undefined' && piece?.status === 'A_PROPO') {
      shouldDisplayButton = true
    } else {
      shouldDisplayButton = false
    }
  } else {
    //si depuis liste POT et validation sur fil Ariane
    if (piece?.status !== 'undefined' && (piece?.status === 'ECHEC' || piece?.status === 'ACCEP')) {
      shouldDisplayButton = false
    }
  }

  const handleChangePrixAchat = (value) => {

    if (value === '') { // au cas ou le champs est vide
      setPrixVente('')
      setPrixAchat('')
      setErrors((prevErrors: any) => ({
        ...prevErrors,
        prixVente: '',
        prixAchat: '',
      }));
      setPieces((prevPieces) => ({
        ...prevPieces,
        prixVente: '',
        prixAchat: '',
      }));
      return;
    }

    const floatFields = ['prixVente', 'prixAchat']

    setPrixAchat(value)
    const margeConv = 1 - marge / 100
    const prixVente = value / margeConv
    const prixVenteConvert = prixVente?.toFixed(2)

    setPrixVente(prixVente)

    // Gestion des erreurs
    setErrors((prevErrors: any) => ({
      ...prevErrors,
      ['prixVente']: '',
      ['prixAchat']: '',
    }))

    //mise à jour du pièce
    setPieces((prevPieces) => ({
      ...prevPieces,
      ['prixVente']: floatFields.includes('prixVente')
        ? prixVenteConvert.replace(',', '.')
        : prixVenteConvert,
      ['prixAchat']: floatFields.includes('prixAchat') ? value.replace(',', '.') : value,
    }))
  }

  const handleChangeMarge = (value) => {

    if (value === '') { // au cas ou le champs est vide
      setMarge('')
      setErrors((prevErrors: any) => ({
        ...prevErrors,
        marge: '',
      }));
      setPieces((prevPieces) => ({
        ...prevPieces,
        marge: '',
      }));
      return;
    }

    const floatFields = ['prixVente', 'marge']

    setMarge(value)
    const margeConv = 1 - value / 100
    const prixVente = prixAchat / margeConv

    const prixVenteConvert = prixVente?.toFixed(2)
    setPrixVente(prixVenteConvert)

    // Gestion des erreurs
    setErrors((prevErrors: any) => ({
      ...prevErrors,
      ['prixVente']: '',
    }))

    //mise à jour du pièce
    setPieces((prevPieces) => ({
      ...prevPieces,
      ['prixVente']: floatFields.includes('prixVente')
        ? prixVenteConvert.replace(',', '.')
        : prixVenteConvert,
      ['marge']: floatFields.includes('marge') ? value.replace(',', '.') : value,
    }))
  }

  // Soumission du formulaire
  const postAction = async () => {
    let isModif = false
    if (isEditPiece || isEditPanier) {
      isModif = true
    }

    try {
      // Valider les valeurs
      await validationSchema.validate(
        {
          ...pieces,
          anomalie: anomalieValue,
          provenance: provenanceValue,
          marge: marge,
          remise: remise,
        },
        {abortEarly: false}
      )

      setLoading(true)

      const action = !isEdit
        ? addPot(
            piece?.demande?.id,
            piece?.typePiece?.id,
            piece?.id,
            pieces,
            anomalieValue,
            images,
            provenanceValue,
            libelle,
            remise,
            marge,
            false,
            pieceInstance
          )
        : updatePot(
            piece?.id,
            piece?.demande?.id,
            piece?.demandePiece?.typePiece?.id,
            piece?.demandePiece?.id,
            pieces,
            anomalieValue,
            images,
            provenanceValue,
            libelle,
            remise,
            marge,
            isModif
          )

      action.then((res) => {
        if (res && res.status === 200 && res?.data) {
          const {potObj, demPiecePropPOT, clientDemande} = res.data
          const demImmat = demPiecePropPOT.clientDemandePiece?.clientDemandeImmat
          const marque = demImmat?.donneesImmatriculation
            ? demImmat?.donneesImmatriculation?.smarque
            : demImmat?.modele
            ? demImmat?.modele?.marque?.nom
            : demImmat?.vehiculeHorsType?.marque
          const modele = demImmat?.donneesImmatriculation
            ? demImmat?.donneesImmatriculation?.smodele
            : demImmat?.modele
            ? demImmat?.modele?.nom
            : demImmat?.vehiculeHorsType?.nom
          if (!isEdit) {
            // Mise à jour de l'affichage du bouton ajout POT après insertion dans la base
            const updatedPieces = piecesProps?.map((p) =>
              p.id === piece.id ? {...piece, typePiecePOT: [potObj], clientDemandePieceProposee:[demPiecePropPOT] } : p
            )
            // nettoyage des photos
            setPiecesProps(updatedPieces)
            images.forEach((img: any) => URL.revokeObjectURL(img.preview))
            setImages([])

            navigate(location.pathname, {
              state: {
                ...state,
                selectedPiecesFromVehicle: updatedPieces,
              },
              replace: true,
            })

            if (setPanier) {
              setPanier((prevPanier) => {
                // TVA POT toujours 20%
                const tauxTva = 20
                const taux = 0

                // const prixReferentielTtc = Number(Number(potObj?.prixVenteTTC)?.toFixed(2)) ?? 0;
                // const prixReferentielHt = Number(Number((prixReferentielTtc / (1 + (tauxTva / 100)))?.toFixed(2)) ?? 0) ?? 0;
                // const prixReferentielHtInitial = prixReferentielHt;
                //
                // const prixVenteProposeeHt = Number((prixReferentielHt - (prixReferentielHt * (taux / 100)))?.toFixed(2)) ?? 0;
                // const prixVenteProposeeTtc = Number((prixVenteProposeeHt * (1 + (tauxTva / 100)))?.toFixed(2)) ?? 0;

                const prixReferentielTtc =
                  Number(Number((potObj?.prixVenteTTC * (1 + tauxTva / 100))?.toFixed(2)) ?? 0) ?? 0
                const prixReferentielHt = Number(Number(potObj?.prixVenteTTC)?.toFixed(2)) ?? 0
                const prixReferentielHtInitial = prixReferentielHt

                // const prixVenteProposeeHt = prixReferentielHt
                const prixVenteProposeeHt = Number(prixReferentielHt) ?? 0
                const prixVenteProposeeTtc = prixReferentielTtc

                const provenancePanier = provenances.find((prov) => prov.value == provenanceValue)

                // transformer label en libellé pour l'afficher temporairement dans le panier'
                const transformedProvenanceData = {
                  code: null,
                  id: provenancePanier?.value,
                  libelle: provenancePanier?.label,
                }

                const clientDemandePiece = demPiecePropPOT?.clientDemandePiece
                return [
                  ...prevPanier,
                  {
                    id: potObj?.id,
                    refConstructeur: '',
                    statut: 'A_PROPO',
                    etat: '',
                    refCasier: '',
                    marque: clientDemandePiece?.marque ?? marque,
                    modele: clientDemandePiece?.modele ?? modele,
                    marquePiece: clientDemandePiece?.marque ?? marque,
                    modelePiece: clientDemandePiece?.modele ?? modele,
                    nomTypePiece: clientDemandePiece?.typePiece?.nom ?? null,
                    nomTypePieceHN: clientDemandePiece?.typePieceHn ?? null,
                    nomTypePieceProposee: potObj?.nomPiece,
                    idTypePiece: null,
                    immat:
                      clientDemandePiece?.clientDemandeImmat?.immatriculation ??
                      marque + ' - ' + modele,
                    demandeImmatId: null,
                    codePiece: demPiecePropPOT?.typePiecePOT?.code,
                    pieceQuantity: clientDemandePiece?.quantite,
                    idPiecePropose: demPiecePropPOT?.id,
                    idPieceEntre: demPiecePropPOT?.idPieceEntre ?? null,
                    isProposed: null,
                    idCLientDemandePiece: clientDemandePiece?.id,
                    immatriculationNonTrouvee: null,
                    kilometrage: null,
                    isTypePiecePOT: true,
                    isAccepted: demPiecePropPOT?.isAccepted,
                    isAcceptedBlocked: demPiecePropPOT?.isAcceptedBlocked,
                    isQuantityReached: false,
                    tauxTva: tauxTva,
                    tauxRemise: 0,
                    fraisDePort: 0,
                    montantRemise: 0,
                    prix: prixReferentielHt,
                    prixReferentiel: prixReferentielHt,
                    prixReferentielHtInitial: prixReferentielHtInitial,
                    prixReferentielHt: prixReferentielHt,
                    prixReferentielTtc: prixReferentielTtc,
                    prixVenteProposee: Number(prixVenteProposeeHt.toFixed(2)),
                    prixVenteProposeeHt: Number(prixVenteProposeeHt.toFixed(2)),
                    prixVenteProposeeTtc: prixVenteProposeeTtc,
                    images: [],
                    provenance: transformedProvenanceData,
                    prixAchatPot: prixAchat,
                    potObj: potObj,
                    pieceInstance: pieceInstance
                  },
                ]
              })
            }

            setAllPieces((prevPieces) =>
              prevPieces.map((p) =>
                p.id === piece.id
                  ? {
                      ...piece,
                      clientDemandePieceProposee: potObj?.demandePiece?.clientDemandePieceProposee,
                      typePiecePOT: [potObj],
                    }
                  : p
              )
            )
          } else {
            if (setPiecesProps) {
              const updatedPieces = piecesProps?.map((p) =>
                p.id === piece?.demandePiece?.id
                  ? {...p, typePiecePOT: [potObj], clientDemandePieceProposee:[demPiecePropPOT]} : p
              )
              setPiecesProps(updatedPieces)
            }

            if (setAllPieces) setAllPieces((prevPieces) =>
              prevPieces.map((p) =>
                p.id === piece?.demandePiece?.id
                  ? {
                    ...p,
                    clientDemandePieceProposee: potObj?.demandePiece?.clientDemandePieceProposee,
                    typePiecePOT: [potObj],
                  }
                  : p
              )
            )

            if (setListPot && listPot !== null) {
              // Modification de la liste des POT si la modification est depuis la page qui liste les POT
              setListPot(
                listPot.map((item) => {
                  if (item?.id === potObj?.id) {
                    const provenancePanier = provenances.find(
                      (prov) => prov.value == provenanceValue
                    )
                    const transformedProvenanceData = {
                      code: null,
                      id: provenancePanier?.value,
                      libelle: provenancePanier?.label,
                    }
                    return {
                      ...item,
                      code: potObj?.code,
                      commandeFournisseur: potObj?.commandeFournisseur,
                      delaisLivraison: potObj?.delaisLivraison,
                      fournisseur: potObj?.fournisseur,
                      images: potObj?.images,
                      nomPiece: potObj?.nomPiece,
                      prixAchatTTC: potObj?.prixAchatTTC,
                      prixVenteTTC: potObj?.prixVenteTTC,
                      status:
                        potObj?.commandeFournisseur?.length > 0 && item?.status === 'ACCEP'
                          ? 'ACCEP'
                          : item?.status,
                      provenance: transformedProvenanceData,
                    }
                  }
                  return item
                })
              )
            }

            // Modification du status du POT et de ces valeurs dans le panier
            // Acceptée Bloquée > Acceptée
            if (setPanier) {
              setPanier((prev) =>
                prev?.map((item) => {
                  if (potObj?.id === item?.id) {
                    // TVA POT toujours 20%
                    const tauxTva = 20

                    const prixReferentielTtc = (potObj?.prixVenteTTC * (1 + tauxTva / 100)) ?? 0
                    const prixReferentielHt = potObj?.prixVenteTTC ?? 0
                    const prixReferentielHtInitial = prixReferentielHt
                    const prixVenteProposeeHt = prixReferentielHt ?? 0
                    const prixVenteProposeeTtc = prixReferentielTtc
                    const roundedPrixVenteProposeeTtc = Math.floor(prixVenteProposeeTtc * 100) / 100

                    // transformer label en libellé pour l'afficher temporairement dans le panier'
                    const transformedProvenanceData = {
                      code: potObj?.provenance?.code,
                      id: potObj?.provenance?.id,
                      libelle: potObj?.provenance?.libelle,
                    }
                    const clientDemandePiece = demPiecePropPOT?.clientDemandePiece
                    return {
                      ...prev,
                      id: potObj?.id,
                      refConstructeur: '',
                      etat: '',
                      refCasier: '',
                      marque: clientDemandePiece?.marque ?? marque,
                      modele: clientDemandePiece?.modele ?? modele,
                      marquePiece: clientDemandePiece?.marque ?? marque,
                      modelePiece: clientDemandePiece?.modele ?? modele,
                      nomTypePiece: clientDemandePiece?.typePiece?.nom ?? null,
                      nomTypePieceHN: clientDemandePiece?.typePieceHn ?? null,
                      nomTypePieceProposee: potObj?.nomPiece,
                      idTypePiece: null,
                      immat:
                        clientDemandePiece?.clientDemandeImmat?.immatriculation ??
                        marque + ' - ' + modele,
                      demandeImmatId: null,
                      codePiece: demPiecePropPOT?.typePiecePOT?.code,
                      pieceQuantity: clientDemandePiece?.quantite,
                      idPiecePropose: demPiecePropPOT?.id,
                      isProposed: null,
                      idCLientDemandePiece: clientDemandePiece?.id,
                      immatriculationNonTrouvee: null,
                      kilometrage: null,
                      isTypePiecePOT: true,
                      isAccepted: (potObj?.commandeFournisseur?.length > 0),
                      isAcceptedBlocked: (potObj?.commandeFournisseur?.length <= 0),
                      statut: (potObj?.commandeFournisseur?.length > 0 && item?.statut === 'BLOQU') ? 'ACCEP' : item?.statut,
                      isQuantityReached: false,
                      tauxTva: tauxTva,
                      tauxRemise: 0,
                      fraisDePort: 0,
                      montantRemise: 0,
                      prix: Number(prixReferentielHt?.toFixed(2)),
                      prixReferentiel: Number(prixReferentielHt?.toFixed(2)),
                      prixReferentielHtInitial: Number(prixReferentielHtInitial?.toFixed(2)),
                      prixReferentielHt: Number(prixReferentielHt?.toFixed(2)),
                      prixReferentielTtc: Number(prixReferentielTtc?.toFixed(2)),
                      prixVenteProposee: Number(prixVenteProposeeHt?.toFixed(2)),
                      prixVenteProposeeHt: Number(prixVenteProposeeHt?.toFixed(2)),
                      prixVenteProposeeTtc: Number(roundedPrixVenteProposeeTtc?.toFixed(2)),
                      images: [],
                      provenance: transformedProvenanceData,
                      prixAchatPot: potObj?.prixAchatTTC,
                      potObj: potObj,
                    }
                  } else return item
                })
              )
            }

            if (isEditPanier || isEditPiece) {
              // ouverture du modal panier après modification du POT
              if(isEditPanier){
                const modalElement = document.getElementById('kt_modal_1')
                if (modalElement) {
                  const modal = Modal.getOrCreateInstance(modalElement)
                  modal.show()
                }
              }
            } else {
              // Modification du status du POT dans le panier
              // Acceptée Bloquée > Acceptée
              if (setPanier) {
                setPanier((prev) =>
                  prev?.map((item) => {
                    if (potObj?.id === item?.id) {
                      return {
                        ...item,
                        isAccepted: potObj?.commandeFournisseur?.length > 0,
                        isAcceptedBlocked: potObj?.commandeFournisseur?.length <= 0,
                        statut:
                          potObj?.commandeFournisseur?.length > 0 && item?.statut === 'ACCEP'
                            ? 'ACCEP'
                            : item?.statut,
                      }
                    } else return item
                  })
                )
              }
            }

            // Mise à jours de la liste des demandes
            if (listDemande && setListDemande) {
              const demandeFound = listDemande?.find((item) => item?.[0]?.id === piece?.demande?.id)
              if (demandeFound) {
                const keyDemandeFound = listDemande?.indexOf(demandeFound)
                setListDemande(
                  listDemande?.map((item, key: number) => {
                    if (key === keyDemandeFound) {
                      return {
                        ...item,
                        0: clientDemande,
                      }
                    } else return item
                  })
                )
              }
            }

            // Modification de la liste des POT dans la fil d'Ariane à modifier
            // Retirer si le POT a une commande fournisseur
            // Mettre à jour si il n'y a pas de commande fournisseur
            if (listePOTAriane && listePOTAriane?.length > 0) {
              // Verification si commande fournisseur n'est pas vide
              const updatedListePOTAriane =
                potObj?.commandeFournisseur?.length > 0
                  ? listePOTAriane?.filter((potAriane) => potAriane?.id !== piece?.id)
                  : listePOTAriane?.map((potAriane) =>
                      potAriane?.id === piece?.id ? potObj : potAriane
                    )
              setListePOTAriane(updatedListePOTAriane)

              // Mise à jours de la demande pour obtenir son statut actuel
              if (setDemandeClient && clientDemande) {
                setDemandeClient(clientDemande)
                setDemandeAriane(clientDemande)
              }
            }
          }

          // Méthode d'affichage du toast de succès
          showToastPOT()

          // Fermeture du modal après insertion
          if (modalRef.current) {
            const modal = Modal.getInstance(modalRef.current)
            setLoading(false)
            modal?.hide()
          }
        }
      })

      setErrors({})
    } catch (err: any) {
      const newErrors = err.inner.reduce((acc: any, curr: any) => {
        acc[curr.path] = curr.message
        return acc
      }, {})
      setErrors(newErrors)
    }
  }

  // Gestion ouverture et fermeture du modal, cleanUp
  useEffect(() => {
    const modal = modalRef.current

    if (modal) {
      modal.addEventListener('hidden.bs.modal', () => {
        setIsModalOpen(false)
        setPieces(potInitValues)
        setMarge(marge)
        setPrixVente('')
        setRemise(0)
        setPrixAchat('')
        setErrors({})
        if (setIsEditPanier) setIsEditPanier(false)
        if (setIsEditPiece) setIsEditPiece(false)
      })

      modal.addEventListener('shown.bs.modal', () => {
        setIsModalOpen(true)
        setLoading(false)
      })
    }

    // Nettoyer l'event listener quand le composant se démonte
    return () => {
      if (modal) {
        modal.removeEventListener('hidden.bs.modal', () => {})
        modal.removeEventListener('shown.bs.modal', () => {})
      }
    }
  }, [])

  // Gestion des copies en ligne
  const handleCopie = (texte, e) => {
    e.stopPropagation()
    copyText(texte, setCheckCopy, 500)
  }

  const handleBlockStatut = () => {
    const idToast = toast.loading('Changement du statut en cours ...')
    try {
      blockStatutPot(piece?.demande?.id, piece?.id).then((requestData) => {
        if (requestData?.status == 200 && requestData?.data != undefined) {
          toast.update(idToast, {
            render: 'Changement du statut terminé avec succes!',
            type: 'success',
            isLoading: false,
            autoClose: 2000,
          })

          // Fermeture du modal après insertion
          if (modalRef.current) {
            const modal = Modal.getInstance(modalRef.current)
            setLoading(false)
            modal?.hide()
          }
        }
      })
    } catch (err: any) {
      toast.update(idToast, {
        render: "Une erreur s'est produite",
        type: 'error',
        isLoading: false,
        autoClose: 2000,
      })
    }
  }

  // Affichage du libellé POT automatique
  const getLibellPOTAutomatique = () => {
    return (
      <div className='d-flex justify-content-between'>
        <p className='text-info fs-5 fw-bold fst-italic'>{libelle}</p>
        {libelle &&
          (checkCopy !== libelle ? (
            <i
              className='ki-duotone ki-copy cursor-pointer fs-2 ms-2'
              onClick={(e) => handleCopie(libelle, e)}
            ></i>
          ) : (
            <i className='ki-duotone ki-copy-success text-primary fs-2'>
              <span className='path1'></span>
              <span className='path2'></span>
            </i>
          ))}
      </div>
    )
  }

  return (
    <>
      <div
        className='modal fade'
        id='modalPOT'
        aria-labelledby='modalPOT'
        tabIndex={-1}
        ref={modalRef}
        aria-hidden={!isModalOpen}
      >
        <div className='modal-dialog modal-lg' style={{maxWidth: '1000px', width: '95%'}}>
          <div className='modal-content'>
            <div className='modal-header'>
              <div className='d-flex align-items-center gap-4'>
                <h5 className='modal-title' id='exampleModalToggleLabel2'>
                  {!isEdit ? 'Création' : 'Modification'} POT
                </h5>
                {listePOTAriane?.length > 1 && isEdit && !isEditPanier && !isEditPiece && (
                  <select
                    className={`form-select form-select-md form-control form-control-md form-control-solid mb-3 mb-lg-0 me-1 w-250px`}
                    onChange={(e) => {
                      setSelectedPOTAriane(
                        listePOTAriane?.find((pot) => pot?.id === Number(e?.target?.value))
                      )
                    }}
                    value={selectedPOTAriane?.id}
                  >
                    {listePOTAriane.map((option, key: number) => (
                      <option key={key} value={option?.id}>
                        {option?.NE} - {option?.nomPiece}
                      </option>
                    ))}
                  </select>
                )}
              </div>
              {isEditPanier ? (
                <div
                  className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                  data-bs-target='#kt_modal_1'
                  data-bs-toggle='modal'
                  aria-label='Close'
                >
                  <KTSVG path='/media/svg/custom/prev-arrow.svg' className='svg-icon svg-icon-2x' />
                </div>
              ) : (
                <div
                  className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                  data-bs-dismiss='modal'
                  aria-label='Close'
                >
                  <KTSVG
                    path='/media/icons/duotune/arrows/arr061.svg'
                    className='svg-icon svg-icon-2x'
                  />
                </div>
              )}
            </div>
            <>
              <div className='modal-body'>
                <div className='row'>
                  <div className='mb-5'>
                    <div className='row'>
                      {piece?.stock !== undefined &&
                        piece.stock !== 'chargement' &&
                        piece.stock > 0 && (
                          <div
                            className='border p-5 mb-5 d-flex justify-content-center align-items-center gap-2'
                            style={{
                              borderRadius: '10px',
                              fontSize: '16px',
                              color: '#ff000096',
                              background: '#ffa5000d',
                              borderColor: '#ffa5000d',
                            }}
                          >
                            <i
                              className='bi bi-exclamation-triangle-fill text-warning'
                              style={{fontSize: '20px'}}
                            ></i>
                            Cette pièce est déjà en stock. Veuillez indiquer la raison pour laquelle
                            vous créez un POT.
                          </div>
                        )}
                      <div className='form-group col-md-6'>
                        <label style={{fontSize: '15px', marginBottom: '10px'}}>Numéro POT</label>
                        <input
                          type='text'
                          className={`form-control form-control-lg form-control-solid mb-3 mb-lg-0 ${
                            errors.ne && ' border-danger'
                          }`}
                          placeholder='NE'
                          name='ne'
                          value={pieces.ne}
                          disabled={true}
                          onChange={handleChange}
                        />
                      </div>
                      <div className='col-md-6'>
                        <label style={{fontSize: '15px', marginBottom: '10px'}}>Désignation</label>
                        <input
                          type='text'
                          className={`form-control form-control-lg form-control-solid mb-3 mb-lg-0 ${
                            errors.nomPiece && ' border-danger'
                          }`}
                          placeholder='Désignation'
                          name='nomPiece'
                          value={pieces?.nomPiece}
                          onChange={handleChange}
                        />
                        {errors.nomPiece && <div className='text-danger'>{errors.nomPiece}</div>}
                      </div>
                    </div>
                    <div className='row mt-5'>
                      <div className='col-md-6'>
                        <label style={{fontSize: '15px', marginBottom: '10px'}}>
                          Fournisseur <span className='text-danger'>*</span>
                        </label>
                        {loadingFournisseur ? (
                          <div className='d-flex justify-content-center align-items-center my-4'>
                            <span className='spinner-border spinner-border-sm align-middle ms-2 w-25px h-25px'></span>
                          </div>
                        ) : (
                          <>
                            <InputGroup className='mb-3'>
                              <select
                                name='fournisseur'
                                className={`form-select form-select-lg form-control form-control-lg form-control-solid mb-3 mb-lg-0 me-1 ${
                                  errors.fournisseur ? 'border-danger' : ''
                                }`}
                                value={pieces.fournisseur}
                                disabled={loadingFournisseur}
                                onChange={(e) => {
                                  setPieces((prev) => ({
                                    ...prev,
                                    fournisseur: e.target.value,
                                  }))
                                  setErrors((prev) => ({
                                    ...prev,
                                    fournisseur: '',
                                  }))
                                }}
                              >
                                {!optionFournisseurSelected && (
                                  <option value=''>
                                    {loadingFournisseur ? (
                                      <span>Chargement ... </span>
                                    ) : (
                                      'Sélectionner un fournisseur'
                                    )}
                                  </option>
                                )}
                                {optionFournisseur.map((option) => (
                                  <option key={option.value} value={option.value}>
                                    {option.label}
                                  </option>
                                ))}
                              </select>
                              <InputGroup.Text
                                id='basic-addon2'
                                role='button'
                                tabIndex={0}
                                data-tooltip-id='modal-tooltip'
                                data-tooltip-content='Créer un fournisseur POT'
                                data-tooltip-place='left'
                                className='cursor-pointer'
                              >
                                <i
                                  className='fa fa-plus-circle text-primary fs-1'
                                  onClick={() => {
                                    if (modalRef.current) {
                                      let bsModal = Modal.getInstance(modalRef.current)
                                      if (!bsModal) {
                                        bsModal = new Modal(modalRef.current)
                                      }
                                      bsModal.hide()
                                    }
                                    setOpenCreationFournisseurPOTModal(true)
                                  }}
                                ></i>
                              </InputGroup.Text>
                            </InputGroup>
                            {errors.fournisseur && (
                              <div className='text-danger'>{errors.fournisseur}</div>
                            )}
                          </>
                        )}
                      </div>
                      <div className='col-md-6'>
                        <label style={{fontSize: '15px', marginBottom: '10px'}}>
                          Délais de livraison (en jours)
                        </label>
                        <input
                          type='number'
                          className={`form-control form-control-lg form-control-solid mb-3 mb-lg-0 ${
                            errors.delai && ' border-danger'
                          }`}
                          placeholder='Délais de livraison (en jours)'
                          name='delai'
                          value={pieces.delai}
                          onChange={handleChange}
                          step={1}
                          min={1}
                          onKeyDown={(e) => {
                            if (e.key === '.' || e.key === ',') {
                              e.preventDefault()
                            }
                          }}
                        />
                        {errors.delai && <div className='text-danger'>{errors.delai}</div>}
                      </div>
                    </div>
                    <div className='row mt-5'>
                      <div className='col-md-4'>
                        <label style={{fontSize: '15px', marginBottom: '10px'}}>
                          Prix d'achat (avec frais de livraison HT){' '}
                          <span className='text-danger'>*</span>
                        </label>
                        <input
                          type='number'
                          className={`form-control form-control-lg form-control-solid mb-3 mb-lg-0 ${
                            errors.prixAchat && ' border-danger'
                          }`}
                          placeholder="Prix d'achat (avec frais de livraison Ht)"
                          name='prixAchat'
                          value={prixAchat}
                          min={0}
                          onChange={(e) => handleChangePrixAchat(e?.target?.value)}
                          onBlur={(e) => handleChangePrixAchat(e?.target?.value)}
                        />
                        {errors.prixAchat && <div className='text-danger'>{errors.prixAchat}</div>}
                      </div>

                      <div className='col-md-2'>
                        <label style={{fontSize: '15px', marginBottom: '10px'}}>
                          Marge (%) <span className='text-danger'>*</span>
                        </label>
                        <input
                          type='number'
                          className={`form-control form-control-lg form-control-solid mb-3 mb-lg-0 ${
                            errors.marge && ' border-danger'
                          }`}
                          placeholder='Marge (%)'
                          name='marge'
                          value={marge}
                          min={0}
                          onChange={(e) => handleChangeMarge(e?.target?.value)}
                          onBlur={(e) => handleChangeMarge(e?.target?.value)}
                        />
                        {errors.marge && <div className='text-danger'>{errors.marge}</div>}
                      </div>

                      {/*<div className='col-md-2'>*/}
                      {/*  <label style={{fontSize: '15px', marginBottom: '10px'}}>Remise (%)</label>*/}
                      {/*  <input*/}
                      {/*    type='number'*/}
                      {/*    className={`form-control form-control-lg form-control-solid mb-3 mb-lg-0 ${*/}
                      {/*      errors.remise && ' border-danger'*/}
                      {/*    }`}*/}
                      {/*    placeholder='Remise (%)'*/}
                      {/*    name='remise'*/}
                      {/*    value={remise}*/}
                      {/*    onChange={handleChange}*/}
                      {/*    disabled*/}
                      {/*  />*/}
                      {/*  {errors.remise && <div className='text-danger'>{errors.remise}</div>}*/}
                      {/*</div>*/}

                      <div className='col-md-4'>
                        <label style={{fontSize: '15px', marginBottom: '10px'}}>
                          Prix de vente (HT) <span className='text-danger'>*</span>
                        </label>
                        <input
                          type='number'
                          className={`form-control form-control-lg form-control-solid mb-3 mb-lg-0 ${
                            errors.prixVente && ' border-danger'
                          }`}
                          placeholder='Prix de vente (HT)'
                          name='prixVente'
                          value={prixVente}
                          min={0}
                          onChange={handleChange}
                          disabled
                        />
                        {errors.prixVente && <div className='text-danger'>{errors.prixVente}</div>}
                      </div>
                    </div>
                    <div className='form-group col-md-12 mt-5'>
                      <label style={{fontSize: '15px', marginBottom: '10px'}}>
                        Référence fournisseur
                      </label>
                      <input
                        type='text'
                        className={`form-control form-control-lg form-control-solid mb-3 mb-lg-0 ${
                          errors.code && ' border-danger'
                        }`}
                        placeholder='Référence fournisseur'
                        name='code'
                        value={pieces?.code}
                        onChange={handleChange}
                        onKeyDown={(e) => {
                          if (e.key === '.' || e.key === ',') {
                            e.preventDefault()
                          }
                        }}
                      />
                      {errors.code && <div className='text-danger'>{errors.code}</div>}
                    </div>
                    <div className='row mt-5'>
                      <div className='col-md-12'>
                        <label style={{fontSize: '15px', marginBottom: '10px'}}>
                          Anomalie de stock <span className='text-danger'>*</span>
                        </label>
                        {loadingAnomalie ? (
                          <div className='d-flex justify-content-center align-items-center my-4'>
                            <span className='spinner-border spinner-border-sm align-middle ms-2 w-25px h-25px'></span>
                          </div>
                        ) : (
                          <>
                            <select
                              name='anomalie'
                              className={`form-select form-select-lg form-control form-control-lg form-control-solid mb-3 mb-lg-0 me-1 ${
                                errors.anomalie ? 'border-danger' : ''
                              }`}
                              value={anomalieValue}
                              disabled={loadingAnomalie}
                              onChange={(e) => {
                                setAnomalieValue(e.target.value)
                                setErrors((prev) => ({
                                  ...prev,
                                  anomalie: '',
                                }))
                              }}
                            >
                              {!optionAnomalieSelected && (
                                <option value=''>
                                  {loadingAnomalie ? (
                                    <span>Chargement ... </span>
                                  ) : (
                                    'Sélectionner une anomalie'
                                  )}
                                </option>
                              )}
                              {anomalies.map((anomalie) => (
                                <option key={anomalie.value} value={anomalie.value}>
                                  {anomalie.label}
                                </option>
                              ))}
                            </select>
                            {errors.anomalie && (
                              <div className='text-danger'>{errors.anomalie}</div>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                    <div className='row mt-5'>
                      <div className='col-md-12'>
                        <label style={{fontSize: '15px', marginBottom: '10px'}}>
                          Provenance <span className='text-danger'>*</span>
                        </label>
                        <select
                          name='provenance'
                          className={`form-select form-select-lg form-control form-control-lg form-control-solid mb-3 mb-lg-0 me-1 ${
                            errors.provenance ? 'border-danger' : ''
                          }`}
                          value={provenanceValue}
                          disabled={!provenances.length}
                          onChange={(e) => {
                            setProvenanceValue(e.target.value)
                            setErrors((prev) => ({
                              ...prev,
                              provenance: '',
                            }))
                          }}
                        >
                          {!optionProvenanceSelected && (
                            <option value=''>
                              {!provenances.length ? (
                                <span>Chargement ... </span>
                              ) : (
                                'Sélectionner une provenance'
                              )}
                            </option>
                          )}
                          {provenances.map((provenance) => (
                            <option key={provenance.value} value={provenance.value}>
                              {provenance.label}
                            </option>
                          ))}
                        </select>
                        {errors.provenance && (
                          <div className='text-danger'>{errors.provenance}</div>
                        )}
                      </div>
                    </div>
                    <div className='row mt-5'>
                      <MultiFilePicker images={images} setImages={setImages} />
                    </div>
                    {isEdit && !isEditPanier && !isEditPiece && (
                      <>
                        <div className='form-group col-md-12'>
                          <label style={{fontSize: '15px', marginBottom: '10px'}}>
                            Commande fournisseur <span className='text-danger'>*</span>
                          </label>
                          <input
                            type='text'
                            className={`form-control form-control-lg form-control-solid mb-3 mb-lg-0 ${
                              errors.code && ' border-danger'
                            }`}
                            placeholder='Commande fournisseur'
                            name='commandeFournisseur'
                            value={pieces?.commandeFournisseur ?? ''}
                            onChange={handleChange}
                          />
                          {errors.commandeFournisseur && (
                            <div className='text-danger'>{errors.commandeFournisseur}</div>
                          )}
                        </div>
                        <div className='form-group col-md-12 mt-5'>
                          <label style={{fontSize: '15px', marginBottom: '10px'}}>
                            Libellé POT automatique
                          </label>
                          {getLibellPOTAutomatique()}
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
              <div className='modal-footer'>
                {!isEditPanier ? (
                  <button type='button' className='btn btn-light' data-bs-dismiss='modal'>
                    Fermer
                  </button>
                ) : (
                  <button
                    type='button'
                    className='btn btn-light'
                    data-bs-target='#kt_modal_1'
                    data-bs-toggle='modal'
                  >
                    Retour
                  </button>
                )}
                {isEdit &&
                  !isEditPanier &&
                  !isEditPiece &&
                    ( piece?.status !== undefined &&
                  (piece?.status !== 'ACCEP' && piece?.status !== 'ECHEC') ) && (
                    <button className='btn btn-light-danger' onClick={handleBlockStatut}>
                      Non disponible
                    </button>
                  )}

                {shouldDisplayButton && (
                  <button type='button' className='btn btn-primary' onClick={postAction}>
                    <span
                      className='indicator-progress d-flex align-items-center'
                      aria-live='polite'
                      aria-busy={loading}
                    >
                      {loading ? (
                        <>
                          {!isEdit
                            ? 'Ajout'
                            : isEditPanier
                            ? 'Modification en cours'
                            : 'Validation en cours'}
                          ...
                          <span
                            className='spinner-border spinner-border-sm align-middle ms-2'
                            role='status'
                            aria-hidden='true'
                          ></span>
                        </>
                      ) : !isEdit ? (
                        'Ajouter'
                      ) : isEditPanier || isEditPiece ? (
                        'Modifier'
                      ) : (
                        'Valider'
                      )}
                    </span>
                  </button>
                )}
              </div>
            </>
          </div>
        </div>
        <Tooltip id='modal-tooltip' />
      </div>
      {openCreationFournisseurPOTModal && (
        <AddFournisseurPOTModal
          show={openCreationFournisseurPOTModal}
          showModal={toggleCreationFournisseurPOTModal}
          setOptionFournisseur={setOptionFournisseur}
          optionFournisseur={optionFournisseur}
          setPieces={setPieces}
          pcs={pcs}
          onClose={(e) => {
            setTimeout(() => {
              if (modalRef.current) {
                const bsModal = Modal.getOrCreateInstance(modalRef.current)
                bsModal.show()
                setPcs(e)
              }
            }, 100)
          }}
        />
      )}
    </>
  )
}

export default ModalPOT
